<template>
    <div class="dialogMask">
        <div>
            <img src="../assets/imgs/readerCenter/dialogSuccess.png" alt="">
            <p>重置密码为：{{ value }}</p>
            <div @click="close">确定</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShow: false,
        }
    },
    props: ["value"],
    computed: {
        isShowDialogPage() {
            return this.$store.state.isShowDialogPage;
        }
    },
    methods: {
        close() {
            let that = this;
            this.$emit('close-dialog',false)
        }
    },
    watch: {
        isShowDialogPage(newV) {
        }
    }
}
</script>

<style lang="scss" scoped>
    .dialogMask{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #000000, $alpha: .5);
        z-index: 999999;
        >div{
            width: 540px;
            height: 430px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            padding-top: 30px;
            border-radius: 20px;
            >img{
                display: block;
                width: 127px;
                height: 127px;
                margin: 0 auto 60px;
            }
            >p{
                color: #1c1c1c;
                font-size: 24px;
                line-height: 26px;
                margin-bottom: 50px;
                text-align: center;
            }
            >div{
                margin: 0 auto;
                color: #fff;
                background: #1AA7E0;
                line-height: 45px;
                width: 138px;
                border-radius: 10px;
                font-size: 24px;
                text-align: center;
                cursor: pointer;
            }
        }
    }
</style>